import { fulfillmentUrl } from 'utils/wrappers';
import { postCSV } from 'utils/xhr';
import Base from 'app/models/base';
import Address from 'app/models/address';

export default Base.extend({
  urlRoot: fulfillmentUrl('orders'),
  nestedModels: {
    destination: Address,
  },

  uploadOrdersCSV(options) {
    postCSV({ url: `${this.urlRoot}?mode=${options.apiModeSelection.getVal()}`, ...options });
  },
});



// WEBPACK FOOTER //
// ./app/models/fulfillment_order.js